import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { HyperFlowsCategory } from '../../interfaces/HyperFlows';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'properties-hyperflows',
  standalone: true,
  imports: [
    CommonModule,
    MatExpansionModule,
    MatIconModule,
    MatButtonModule
  ],
  templateUrl: './properties-hyperflows.component.html',
  styleUrl: './properties-hyperflows.component.scss'
})
export class PropertiesHyperflowsComponent {
  @Input() hyperflows?: HyperFlowsCategory[] | null;
}
